exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".filterItem {\n  display: flex;\n  justify-content: space-between;\n}\n.filterItem .labelWrap {\n  width: 64px;\n  line-height: 28px;\n  margin-right: 12px;\n  justify-content: space-between;\n  display: flex;\n  overflow: hidden;\n}\n.filterItem .item {\n  flex: 1;\n}\n", "", {"version":3,"sources":["D:/ZjgHm/furuicode/frui_backend/front/src/components/FilterItem/FilterItem.less"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,+BAA+B;CAChC;AACD;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;CAClB;AACD;EACE,QAAQ;CACT","file":"FilterItem.less","sourcesContent":[".filterItem {\n  display: flex;\n  justify-content: space-between;\n}\n.filterItem .labelWrap {\n  width: 64px;\n  line-height: 28px;\n  margin-right: 12px;\n  justify-content: space-between;\n  display: flex;\n  overflow: hidden;\n}\n.filterItem .item {\n  flex: 1;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/FilterItem/FilterItem.less
// module id = 1286
// module chunks = 0